<template>
  <div>
    <div v-for="(item, idx) in faqList" :key="idx" :class="['border border-[#ececec] rounded-xl mb-2 w-full', openIndex === idx ? 'bg-[var(--white-opacity-4)]' : 'bg-white']">
      <button class="w-full flex justify-between items-center p-6 text-left focus:outline-none" @click="toggle(idx)">
        <span class="font-semibold text-[18px] text_color">{{ idx + 1 }}. {{ item.question }}</span>
        <ThemeImage :icon="imageNames.DOWN_ARROW_BLACK_ICON" alt="down_arrow" :class="['transition-transform duration-200', { 'rotate-180': openIndex === idx }]" width="24" height="24" />
      </button>
      <div v-if="openIndex === idx" class="px-6 pb-6 text-[15px] text-[#222] whitespace-pre-line">
        <template v-if="Array.isArray(item.answer)">
          <div v-for="(line, i) in item.answer" :key="i">
            <template v-if="line.startsWith('•')">
              <ul class="list-disc pl-6">
                <li>{{ line.replace(/^•\s*/, '') }}</li>
              </ul>
            </template>
            <template v-else>
              <div v-if="line.endsWith(':')" class="font-bold mt-2 mb-1">{{ line }}</div>
              <div v-else-if="line.trim() === ''" style="height: 8px"></div>
              <div v-else>{{ line }}</div>
            </template>
          </div>
        </template>
        <template v-else>
          {{ item.answer }}
        </template>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref } from 'vue';
import ThemeImage from '@/components/custom/ThemeImage.vue';
import { imageNames } from '@/javascript/imageConstants';
const props = defineProps({
  faqList: {
    type: Array,
    required: true,
  },
});
const openIndex = ref(null);
const toggle = (idx) => {
  openIndex.value = openIndex.value === idx ? null : idx;
};
</script>

<style scoped>
.rotate-180 {
  transform: rotate(180deg);
}
</style>
